'use client';

import { useState } from 'react';
import { acceptMarketplaceSellerTerms } from '@/platform/vendor/api';
import { MarketplaceSellerTermsAcceptance } from '@/platform/legal/MarketplaceSellerTermsAcceptance';

export type MarketplaceSellerTermsReacceptProps = {
  onAccepted: () => void;
};

export function MarketplaceSellerTermsReaccept({ onAccepted }: MarketplaceSellerTermsReacceptProps) {
  const [agreed, setAgreed] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  async function submit() {
    if (!agreed) {
      setError('Accept the updated marketplace seller terms to continue.');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      await acceptMarketplaceSellerTerms();
      onAccepted();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Could not save acceptance');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <section className="marketplace-seller-terms-reaccept form-error" role="alert">
      <h2>Seller terms updated</h2>
      <p>Review and accept the current marketplace seller terms to continue selling.</p>
      <MarketplaceSellerTermsAcceptance checked={agreed} onChange={setAgreed} disabled={submitting} />
      <p>
        <button type="button" className="btn btn-primary" disabled={submitting || !agreed} onClick={() => void submit()}>
          {submitting ? 'Saving…' : 'Accept and continue'}
        </button>
      </p>
      {error && <p className="form-error">{error}</p>}
    </section>
  );
}
